import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  writeIntro: {
    height: "100%",
  },
  writeMain: {
    width: 600,
  },
  writeTitle: {
    height: 150,
    fontSize: 28,
    fontWeight: 500,
    textAlign: "center",
    lineHeight: 1.6,
    "& > span": {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
  },
  button: {
    width: 266,
    height: 48,
  },
  margin: {
    margin: theme.spacing(1),
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
  },
  subTitle: {
    fontSize: 18,
    marginTop: 16,

    // color: "#747474",
    textAlign: "center",
    fontWeight: 500,
  },
  bold: {
    fontWeight: 800,
  },
  contentsMain: {
    padding: 32,
  },
  contents: {
    padding: "32px 24px",
  },
  que: {
    fontSize: 20,
    color: "#333333",
    paddingTop: 12,
    paddingBottom: 12,
  },
  radio: {
    marginRight: theme.spacing(5),
  },
  blue: {
    color: theme.palette.primary.main,
  },
  footer: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  buttonLine: {
    paddingTop: 4,
    borderTop: "1px solid rgb(0 0 0 / 14%)",
  },
}));

const EvaluationComp = ({ name }) => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [result, setResult] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      setResult(false);
    }, 100);
  };
  const handleClickOpen = (event) => {
    event.stopPropagation();
    setOpen(true);
  };
  const handleHome = () => {
    history.push("/");
  };
  return (
    <>
      <Grid
        container
        justify="center"
        alignItems="center"
        direction="column"
        className={classes.writeIntro}
      >
        <Grid
          container
          justify="center"
          alignItems="center"
          direction="column"
          className={classes.writeMain}
        >
          <Grid className={classes.writeTitle}>
            {name} <span>조기검진</span>을 받으시겠습니까?
            <br />
          </Grid>
          <Grid container justify="space-around" alignItems="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleClickOpen}
            >
              조기검진을 받겠습니다.
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleHome}
            >
              홈으로 돌아가기
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth={"xs"}
        open={open}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className={classes.contentsMain}
        >
          <Grid container justify="center" alignItems="center">
            <Grid className={classes.title}>{name} 조기검진</Grid>
          </Grid>
          {!result && (
            <Grid className={classes.subTitle}>
              암 조기 검진 이득/손해 소개를 다 시청하셨습니다. &nbsp;
              <br />
              감사합니다.
            </Grid>
          )}
        </DialogTitle>
        <DialogActions>
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.buttonLine}
          >
            <Button
              color="primary"
              style={{ padding: 8 }}
              fullWidth
              onClick={handleClose}
            >
              닫기
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EvaluationComp;
